import {
  TableCellType,
  TableHeader,
} from "../../../../components/custom-table/table";
import { ProviderOptionsTableColumnKeys } from "../../../../enums/tableColumnKeys";

export const ProviderOptionsTableHeader: TableHeader[] = [
  {
    label: "Name",
    key: ProviderOptionsTableColumnKeys.NAME,
    order: 1,
    width: 60,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Show on List",
    key: ProviderOptionsTableColumnKeys.SHOW_ON_LIST,
    order: 2,
    width: 30,
    sortable: false,
    type: TableCellType.TOGGLE_SWITCH,
  },
  {
    label: "",
    key: ProviderOptionsTableColumnKeys.DELETE,
    order: 3,
    width: 10,
    sortable: false,
    type: TableCellType.DELETE_ICON,
  },
];
